export default __webpack_public_path__ + "static/bed-bath-beyond-1-1-09e61fccc789a0243f91177b8125d9f4.webp";